import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { IProjectRepo } from '../shared/projectRepo';
import { IBranch } from '../shared/branch';

@Injectable()
export class BatchBranchService {
   
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  private cache: { [filter: string]: IProjectRepo[] } = {};
  private projectListCache: { name: string, group: string }[] = null;

  constructor(private http: HttpClient) { }

  loadProjectList(): Observable<{ name: string, group: string }[]> {
    if (this.projectListCache) {
      return of(this.projectListCache);
    }
    return this.http.get<{ name: string, group: string }[]>("/api/projects/list")
      .pipe(
        map(data => {
          this.projectListCache = data;
          return data;
        }),
        catchError(this.handleError<{ name: string, group: string }[]>('loadProjectList', [])));
  }

  isCached(filter: string): boolean {
    return !!this.cache[filter];
  }

  loadProjectsAndRepos(filter: string): Observable<IProjectRepo[]> {
    if (this.cache[filter]) {
      return of(this.cache[filter]);
    }
    return this.http.get<IProjectRepo[]>(`/api/projects/repos?filter=${encodeURIComponent(filter)}`)
      .pipe(
        map(data => {
          this.cache[filter] = data;
          return data;
        }));
  }

  clearCache() {
    this.cache = {};
    this.projectListCache = null;
  }

  createBatchBranches(dto: IBranch) {
    return this.http.post<any>("/api/branch", dto, this.httpOptions)
      .pipe(
        catchError(this.handleError<any>("createBatchBranches", dto))
      );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      //console.error(error);
      return of(result as T);
    }
  }
}
